import { logoUrl } from "@/lib/i18n";

const initials = (name) => name.replace(/\(.*\)/, "").trim();

export const BrandLogo = ({ name, size = "md" }) => {
  const src = logoUrl(name);
  const h = size === "lg" ? "h-12 w-24" : "h-9 w-16";
  return (
    <span className={`flex shrink-0 items-center justify-center overflow-hidden ${h}`}>
      {src ? (
        <img src={src} alt={`${name} logo`} loading="lazy" className="logo-white h-full w-full object-contain" />
      ) : (
        <span className="grid h-full w-full place-items-center rounded-lg bg-white/10 px-1 font-display text-[11px] font-extrabold uppercase tracking-wide text-white">{initials(name)}</span>
      )}
    </span>
  );
};
